import createIcon from '../../createIcon';

/**
 * @component @name PeopleAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjY3IDEzLjEzQzE4LjA0IDE0LjA2IDE5IDE1LjMyIDE5IDE3VjIwSDIzVjE3QzIzIDE0LjgyIDE5LjQzIDEzLjUzIDE2LjY3IDEzLjEzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgMTJDMTEuMjA5MSAxMiAxMyAxMC4yMDkxIDEzIDhDMTMgNS43OTA4NiAxMS4yMDkxIDQgOSA0QzYuNzkwODYgNCA1IDUuNzkwODYgNSA4QzUgMTAuMjA5MSA2Ljc5MDg2IDEyIDkgMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDEyQzE3LjIxIDEyIDE5IDEwLjIxIDE5IDhDMTkgNS43OSAxNy4yMSA0IDE1IDRDMTQuNTMgNCAxNC4wOSA0LjEgMTMuNjcgNC4yNEMxNC41IDUuMjcgMTUgNi41OCAxNSA4QzE1IDkuNDIgMTQuNSAxMC43MyAxMy42NyAxMS43NkMxNC4wOSAxMS45IDE0LjUzIDEyIDE1IDEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDEzQzYuMzMgMTMgMSAxNC4zNCAxIDE3VjIwSDE3VjE3QzE3IDE0LjM0IDExLjY3IDEzIDkgMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PeopleAlt = createIcon('PeopleAlt', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z',
      key: '6ts0b3',
    },
  ],
  [
    'path',
    {
      d: 'M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z',
      key: 'bq9obt',
    },
  ],
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z',
      key: '1plhiy',
    },
  ],
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13Z',
      key: 'wie4vr',
    },
  ],
]);

export default PeopleAlt;
